import React, { useEffect, useState } from "react";
import Images from "../../utils/images";
import ProfileList from "../ProfileList/ProfileList";
import Spinner from "../Spinner/Spinner";
import Filter from "../../Admin/Pages/Filter/Filter";
import MessageBar, {
  config,
  DOBASEURL,
  errorNotify,
  getValueFromLocalStorage,
  localStorageKey,
  successNotify,
} from "../../utils/helper";
import { authorizedGet, authorizedPost } from "../../Config/networkWithToken";
import configuration from "../../Config/configuration";
import Pagination from "../Pagination/Pagination";
import Strings from "../../utils/Strings";
import { GoDotFill } from "react-icons/go";
import { ItemsPerPages } from "../../utils/data";
import { Link } from "react-router-dom";
import { useSearchParams } from "react-router-dom";
import RejectModel from "../RejectModel/RejectModel";

const safeJoin = (val) => 
  Array.isArray(val) ? val.join(", ") : (val || "N/A");

const ExpectationMore = ({ expectationData }) => {
  const [open, setOpen] = useState(false);

  if (!expectationData) return null;

  const items = [
    { label: "Age From", value: expectationData?.ageFrom },
    { label: "Age To", value: expectationData?.ageTo },
    { label: "Height From", value: expectationData?.heightFrom },
    { label: "Height To", value: expectationData?.heightTo },
    {
      label: "No Of Hare Krishna Mantra",
      value: expectationData?.expetedCountOfMantra,
    },
    {
      label: "Regulative Principles",
      value: safeJoin(expectationData?.expectedRegulativePrinciples),
    },
    { label: "Caste", value: safeJoin(expectationData?.expetedCaste) },
    {
      label: "Sub Caste",
      value: safeJoin(expectationData?.expetedSubcaste),
    },
    {
      label: "Education",
      value: safeJoin(expectationData?.expetedEducation),
    },
    {
      label: "Employed In",
      value: safeJoin(expectationData?.expetedEmployedIn),
    },
    { label: "City", value: expectationData?.expectedCity },
    {
      label: "Country",
      value: safeJoin(expectationData?.expetedCountrysLiving),
    },
    {
      label: "Manglik",
      value: safeJoin(expectationData?.expectedManglick),
    },
    { label: "Religion", value: expectationData?.expetedReligion },
    {
      label: "Ethnicities",
      value: safeJoin(expectationData?.expetedEthnicities),
    },
    {
      label: "Marital Status",
      value: safeJoin(expectationData?.expetedMaritalStatus),
    },
    {
      label: "Mother Tongue",
      value: safeJoin(expectationData?.expetedMotherTongue),
    },
    {
      label: "Languages",
      value: safeJoin(expectationData?.expetedLanguagesCanSpeak),
    },
    {
      label: "Partner Description",
      value: safeJoin(expectationData?.expetedPartnerDescription),
    },
    {
      label: "Occupations",
      value: safeJoin(expectationData?.expetedOccupations),
    },
    {
      label: "Annual Income From",
      value: expectationData?.expetedIncomeFrom,
    },
    { label: "Annual Income To", value: expectationData?.expetedIncomeTo },
    {
      label: "Country Currency",
      value: safeJoin(expectationData?.countryCurrency),
    },
    {
      label: "Wants NRI",
      value: safeJoin(expectationData?.expetedWantNRI),
    },
    {
      label: "Spiritual Status",
      value: safeJoin(expectationData?.expetedSpiritualStatus),
    },
    {
      label: "Spiritual Master",
      value: safeJoin(expectationData?.expetedSpiritualMaster),
    },
  ].filter((item) => item.value);

  
};

const UserInterest = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const initialTab = parseInt(searchParams.get("tab")) || 0;
  const [activeTab, setActiveTab] = useState(initialTab);
  const [userList, setUserList] = useState([]);
  const [saveUserList, setSaveUserlist] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showFilter, setShowFilter] = useState(false);
  const [filteredData, setFilteredData] = useState(false);
  const [userRole, setUserRole] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [requests, setRequest] = useState([]);
  const [acceptbuttonLoading, setAcceptButtonLoading] = useState(false);
  const [rejectButtonLoading, setRejectButtonLoading] = useState(false);
  const [disableButton, setDisableButton] = useState(false);
  const [approvalDecision, setApprovalDecision] = useState(null);
  const [loadingrequestId, setLoadingRequestId] = useState(null);
  const [acceptedUsers, setAcceptedUsers] = useState([]);
  const gender = getValueFromLocalStorage(localStorageKey.USERDATA, "gender");
  const userId = getValueFromLocalStorage(localStorageKey.USERDATA, "_id");
  const [canSendRequest, setCanSendRequest] = useState(false);
  const [isCommentSectionOpen, setIsCommentSectionOpen] = useState(false);
  const [comment, setComment] = useState("");
  const [error, setError] = useState(false);
  const [requestedId, setRequestedId] = useState(null);
  const [rejectedUsers, setRejectedusers] = useState([]);
  const [isBlocked, setIsBlocked] = useState(false);
  const itemsPerPage = ItemsPerPages;
  const requestedUserId = getValueFromLocalStorage(
    localStorageKey.USERDATA,
    "_id",
  );

  useEffect(() => {
    fetchUserRole();
    if (initialTab === 1) {
      fetchAllRequests();
    } else if (initialTab === 2 || initialTab === 3) {
      approveRequests();
    } else {
      fetchAllUserData();
    }
  }, []);

  const tabList = [
    { name: "Users" },
    { name: "Proposals" },
    { name: "Accepted Users" },
    { name: "Not Accepted Users" },
  ];

  const fetchUserRole = async () => {
    const role = getValueFromLocalStorage(localStorageKey.USERDATA, "role");
    if (role) {
      setUserRole(role);
    }
  };

  const fetchAllUserData = async () => {
    setLoading(true);
    try {
      const res = await authorizedGet(
        `${configuration.apis.searchAndSent}?gender=${gender}&userId=${userId}`,
        config,
      );
      console.log("fetchAllUserData", res);

      const response = res?.data?.data?.userDetails;
      if (res?.data?.status) {
        let users = [];
        setCanSendRequest(res?.data?.data?.canSendRequest);
        response.forEach((list) => {
          if (
            list?.suggestionStatus === null ||
            list?.suggestionStatus === "Rejected"
          ) {
            if (
              list?.requestStatus === null ||
              (list?.requestStatus === "Rejected" && list?.request?.userReject)
            ) {
              users.push(list);
            }
          }
        });
        setUserList(users);
        setSaveUserlist(users);
      }
    } catch (err) {
      let errorMessage =
        "An unexpected error occurred. Please try again later.";

      if (err.response) {
        errorMessage =
          err.response.data.message || "Server error. Please try again.";
      } else if (err.request) {
        errorMessage = "Network error ";
      }

      errorNotify(errorMessage);
    } finally {
      setLoading(false);
    }
  };

  const handleTabClick = (index) => {
    setActiveTab(index);
    setSearchParams({ tab: index });

    if (index === 1) fetchAllRequests();
    if (index === 2 || index === 3) approveRequests();
  };
 
  const handleApplyFilters = async (queryParams) => {
    try {
      setLoading(true);
      const res = await authorizedGet(
        `${configuration.apis.userFilter}?userId=${userId}&${queryParams}`,
        config,
      );
      const response = res?.data?.data?.userDetails;
      if (res?.data?.status) {
        let users = [];
        response.forEach((list) => {
          if (
            list?.suggestionStatus === null ||
            list?.suggestionStatus === "Rejected"
          ) {
            if (
              list?.requestStatus === null ||
              (list?.requestStatus === "Rejected" && list?.request)
            ) {
              users.push(list);
            }
          }
        });
        setUserList(users);
        setFilteredData(true);
      } else {
        setUserList([]);
        setFilteredData(true);
      }
    } catch (err) {
      errorNotify(Strings.ERROR);
      console.error("Error fetching data:", err);
    } finally {
      setLoading(false);
    }
  };

  const fetchAllRequests = async () => {
    try {
      setLoading(true);
      const res = await authorizedGet(
        `${configuration.apis.userGetRequest}?userId=${userId}`,
        config,
      );
      const response = res?.data;
      if (response?.status) {
        setRequest(response?.data);
      }
    } catch (error) {
      console.log(error);
      errorNotify("Unexpected Error");
    } finally {
      setLoading(false);
    }
  };

  const handleClearFilter = () => {
    setFilteredData(false);
    setUserList(saveUserList);
  };

  const toggleFilter = () => setShowFilter(!showFilter);

  const totalPages = Math.ceil(userList.length / itemsPerPage);

  const currentUsers = userList.slice(
    (currentPage - 1) * itemsPerPage,
    currentPage * itemsPerPage,
  );

  const handleApproval = async (decision, requestId) => {
    setLoadingRequestId(requestId);
    try {
      const data = {
        userId: userId,
        requestId: requestId,
        action: decision,
        comments: comment,
        isBlocked: decision === "reject" ? isBlocked : false,
      };

      if (decision === "approve") {
        setAcceptButtonLoading(true);
      } else {
        setRejectButtonLoading(true);
      }

      const res = await authorizedPost(
        configuration.apis.userApproval,
        data,
        config,
      );

      const response = res?.data?.data;
      if (res?.data?.status) {
        successNotify(res?.data?.message);

        if (activeTab === 2) {
          setAcceptedUsers((prevRequests) =>
            prevRequests.filter((request) => request._id !== requestId),
          );
        }

        const users = [];
        response.forEach((value) => {
          if (value?.requestStatus === "Pending") {
            users.push(value);
          }
        });
        setRequest(users);
      } else {
        errorNotify(res?.data?.message);
      }
    } catch (error) {
      errorNotify(Strings.ERROR);
      console.log(error);
    } finally {
      setAcceptButtonLoading(false);
      setRejectButtonLoading(false);
      setLoadingRequestId(null);
      setIsBlocked(false);
    }
  };

  const approveRequests = async () => {
    try {
      setLoading(true);
      const res = await authorizedGet(
        `${configuration.apis.approveRequest}?userId=${userId}`,
        config,
      );
      const response = res?.data?.data;
      if (res?.data?.status) {
        const acceptedUsers = [];
        const rejectedUsers = [];

        response?.approved?.forEach((value) => {
          acceptedUsers.push(value);
        });

        response?.rejected?.forEach((value) => {
          rejectedUsers.push(value);
        });

        setAcceptedUsers(acceptedUsers);
        setRejectedusers(rejectedUsers);
      }
    } catch (error) {
      console.log(error);
      errorNotify("Unexpected Error");
    } finally {
      setLoading(false);
    }
  };

  const handleAction = (requestedId, decision) => {
    setRequestedId(requestedId);
    if (decision === "approve") {
      handleApproval(decision, requestedId);
    } else {
      setIsCommentSectionOpen(true);
    }
  };

  const handleNoteChange = (event) => {
    setError(false);
    setComment(event.target.value);
  };

  const closeModal = () => {
    setComment("");
    setError(false);
    setIsCommentSectionOpen(false);
  };

  const handleSaveComment = () => {
    if (comment.length < 15) {
      setError(true);
    } else {
      handleApproval("reject", requestedId);
      setIsCommentSectionOpen(false);
      setError(false);
      setComment("");
    }
  };

  const profileDetails = (list) => {
    const isOwnProfile = userId === list?.requestedUser?._id;
    const data = isOwnProfile ? list?.user : list?.requestedUser;

    const safeJoin = (arr) => (Array.isArray(arr) ? arr.join(", ") : "N/A");

    const details = [
      {
        label: Strings.DOB,
        value: data?.dob
          ? new Date(data.dob).toLocaleDateString("en-CA")
          : "N/A",
      },
      { label: Strings.BIRTH_TIME, value: data?.birthTime || "N/A" },
      { label: Strings.BIRTH_CITY, value: data?.birthCity || "N/A" },
      { label: Strings.HEIGHT, value: data?.height || "N/A" },
      { label: Strings.MOTHERTONGUE, value: data?.motherTongue || "N/A" },
      { label: Strings.EDUCATION, value: safeJoin(data?.education) },
      { label: Strings.OCCUPATIONS, value: safeJoin(data?.occupations) },
      { label: Strings.ANNUAL_INCOME, value: data?.annualIncome || "N/A" },
      {
        label: Strings.SPIRITUAL_STATUS,
        value: data?.spiritualStatus || "N/A",
      },
      { label: Strings.CASTE, value: data?.caste || "N/A" },
    ];

    if (list?.comments) {
      details.push({
        label: "Declined Reason",
        value: list?.comments,
      });
    }

    if (list?.rejectedby) {
      details.push({
        label: "Not Accepted By",
        value:
          list?.rejectedby === "admin"
            ? "Admin"
            : isOwnProfile
              ? "Other user"
              : "You",
      });
    }

    return details;
  };

  return (
    <div className="flex w-full flex-col px-3 py-12 md:mt-10">
      <div className="mb-3 h-auto w-full rounded-lg bg-bgWhite p-4 shadow-md">
        <div className="flex flex-col items-center justify-between gap-5 border-b text-textGreen md:flex-row">
          <ul className="font-jost flex w-full flex-col md:w-auto md:flex-row">
            {tabList.map((list, index) => (
              <li
                key={index}
                className={`cursor-pointer px-4 py-2 text-center transition-all sm:text-xs md:text-base ${
                  activeTab === index
                    ? "border-b-2 border-textYellow text-textYellow"
                    : "hover:bg-gray-100 hover:text-textYellow"
                }`}
                onClick={() => {
                  if (activeTab !== 1 || index !== 1) {
                    handleTabClick(index);
                  }
                }}
              >
                {list.name}
              </li>
            ))}
          </ul>

          {activeTab === 0 && (
            <div className="font-jost mt-4 flex gap-2 md:mt-0">
              <button
                className="rounded-lg bg-textYellow px-4 py-2 text-bgWhite"
                onClick={toggleFilter}
              >
                {showFilter ? "Hide Filter" : "Show Filter"}
              </button>
              <button
                className="rounded-lg bg-red-600 px-4 py-2 text-bgWhite"
                onClick={handleClearFilter}
              >
                Clear Filter
              </button>
            </div>
          )}
        </div>

        {loading ? (
          <div className="flex h-screen items-center justify-center">
            <Spinner />
          </div>
        ) : (
          <>
            <div className="font-jost mt-4">
              {filteredData && activeTab === 0 && (
                <p className="mb-2 text-lg text-textGreen">
                  Filtered Result Users:
                </p>
              )}

              {activeTab === 0 && (
                <>
                  {userList.length === 0 ? (
                    <div>
                      <p className="text-center">
                        No Users found for your criteria!
                      </p>
                    </div>
                  ) : (
                    <>
                      {currentUsers.map((item, index) => (
                        <div key={index}>
                          <ProfileList
                            userData={item}
                            role={userRole}
                            canSendRequest={canSendRequest}
                          />
                          <ExpectationMore
                            expectationData={item?.profile?.expectations}
                          />
                        </div>
                      ))}
                      <Pagination
                        currentPage={currentPage}
                        totalPages={totalPages}
                        handlePageChange={setCurrentPage}
                      />
                    </>
                  )}
                </>
              )}
              
 
              {activeTab === 1 && (
                <>
                  {requests.length === 0 ? (
                    <div className="flex flex-col items-center justify-center">
                      <p className="text-center">No Proposals Available!</p>
                    </div>
                  ) : (
                    <>
                      {requests.map((list, index) => (
                        <div
                          key={index}
                          className="relative mb-4 flex flex-col gap-4 rounded-lg border border-gray-200 bg-bgWhite p-4 shadow-md md:flex-row md:items-center md:justify-between"
                        >
                         
                          <div className="flex-shrink-0">
                            <img
                              src={
                                list?.requestedUser?.photos?.length > 0
                                  ? DOBASEURL + list?.requestedUser?.photos?.[0]
                                  : gender === "male"
                                    ? Images.WOMEN
                                    : Images.MEN
                              }
                              onContextMenu={(e) => e.preventDefault()}
                              onDragStart={(e) => e.preventDefault()}
                              alt=""
                              className="h-16 w-16 rounded-xl object-cover blur"
                            />
                          </div>

                        
                          <div className="flex flex-1 flex-wrap gap-x-4 gap-y-1 text-sm">
                            {[
                              {
                                label: Strings.DOB,
                                value: new Date(
                                  list?.requestedUser?.dob,
                                ).toLocaleDateString("en-CA"),
                              },
                              {
                                label: Strings.BIRTH_TIME,
                                value: list?.requestedUser?.birthTime,
                              },
                              {
                                label: Strings.BIRTH_CITY,
                                value: list?.requestedUser?.birthCity,
                              },
                              {
                                label: Strings.HEIGHT,
                                value: list?.requestedUser?.height,
                              },
                              {
                                label: Strings.MOTHERTONGUE,
                                value: list?.requestedUser?.motherTongue,
                              },
                              {
                                label: Strings.EDUCATION,
                                value:
                                  list?.requestedUser?.education?.join(", "),
                              },
                              {
                                label: Strings.OCCUPATIONS,
                                value:
                                  list?.requestedUser?.occupations?.join(", "),
                              },
                              {
                                label: Strings.ANNUAL_INCOME,
                                value: list?.requestedUser?.annualIncome,
                              },
                              {
                                label: Strings.SPIRITUAL_STATUS,
                                value: list?.requestedUser?.spiritualStatus,
                              },
                              {
                                label: Strings.CASTE,
                                value: list?.requestedUser?.caste,
                              },
                            ]
                              .filter((item) => item.value)
                              .map((item, idx) => (
                                <span
                                  key={idx}
                                  className="flex items-center gap-1"
                                >
                                  <GoDotFill className="text-xs text-textBlack" />
                                  <span>
                                    {item.label} :{" "}
                                    <span className="text-textGreen">
                                      {item.value}
                                    </span>
                                  </span>
                                </span>
                              ))}
                          </div>

                         
                          <div className="flex flex-row items-center gap-2 md:flex-col">
                            <button
                              className="rounded-lg bg-green-500 px-8 py-2 text-sm text-white md:px-6"
                              onClick={() => handleAction(list._id, "approve")}
                              disabled={loadingrequestId === list._id}
                            >
                              {loadingrequestId === list._id &&
                              acceptbuttonLoading ? (
                                <Spinner size={5} />
                              ) : (
                                "Accept"
                              )}
                            </button>
                            <button
                              className="rounded-lg bg-red-600 px-8 py-2 text-sm text-white md:px-6"
                              onClick={() => handleAction(list._id, "reject")}
                              disabled={loadingrequestId === list._id}
                            >
                              {loadingrequestId === list._id &&
                              rejectButtonLoading ? (
                                <Spinner size={5} />
                              ) : (
                                "Decline"
                              )}
                            </button>
                          </div>
                        </div>
                      ))}
                    </>
                  )}
                </>
              )}

              {activeTab === 2 && (
                <>
                  {acceptedUsers?.length === 0 ? (
                    <div className="flex flex-col items-center justify-center">
                      <p className="text-center">No Data found!</p>
                    </div>
                  ) : (
                    <>
                      {acceptedUsers?.map((list, index) => (
                        <div
                          key={index}
                          className="relative mb-4 flex flex-col gap-2 rounded-lg border border-gray-200 bg-bgWhite p-2 shadow-md md:flex-row md:justify-between"
                        >
                          <div className="flex w-full flex-col items-center justify-center gap-2 md:w-[85%] md:flex-row md:justify-between">
                            <div className="md:h-[120px] md:w-[45%] xl:h-[80px] xl:w-[20%]">
                              <img
                                src={
                                  userId === list?.requestedUser?._id
                                    ? list?.user?.images?.length > 0
                                      ? DOBASEURL + list?.user?.images?.[0]
                                      : gender === "male"
                                        ? Images.WOMEN
                                        : Images.MEN
                                    : list?.requestedUser?.images?.length > 0
                                      ? DOBASEURL +
                                        list?.requestedUser?.images?.[0]
                                      : gender === "male"
                                        ? Images.WOMEN
                                        : Images.MEN
                                }
                                onContextMenu={(e) => e.preventDefault()}
                                onDragStart={(e) => e.preventDefault()}
                                alt=""
                                className="h-full w-full rounded-xl object-cover"
                              />
                            </div>
                            <div className="flex flex-1 flex-col">
                              <ul className="mt-4 flex flex-wrap items-center gap-2 text-sm">
                                {profileDetails(list)?.map((item, idx) => (
                                  <li
                                    key={idx}
                                    className="flex items-center gap-1 text-base"
                                  >
                                    <GoDotFill className="text-sm text-textBlack" />
                                    <span className="font-medium">
                                      {item.label} :{" "}
                                      <span className="font-normal text-textGreen">
                                        {item.value}
                                      </span>
                                    </span>
                                  </li>
                                ))}
                              </ul>
                              <ExpectationMore
                                expectationData={
                                  userId === list?.requestedUser?._id
                                    ? list?.user?.profile?.expectations
                                    : list?.requestedUser?.profile?.expectations
                                }
                              />
                            </div>
                          </div>
                          <div className="flex flex-col items-center justify-center gap-2">
                            <Link
                              to={`/interest/viewProfile/${userId === list?.requestedUser?._id ? list?.user?._id : list?.requestedUser?._id}/${requestedUserId}`}
                              className="w-full"
                            >
                              <button className="min-w-[120px] rounded-lg bg-textYellow px-4 py-2 text-sm text-white">
                                View Profile
                              </button>
                            </Link>
                            <button
                              className="min-w-[120px] rounded-lg bg-red-600 px-4 py-2 text-sm text-white"
                              onClick={() => handleAction(list._id, "reject")}
                              disabled={loadingrequestId === list._id}
                            >
                              {loadingrequestId === list._id &&
                              rejectButtonLoading ? (
                                <Spinner size={5} />
                              ) : (
                                "Not Accept"
                              )}
                            </button>
                          </div>
                        </div>
                      ))}
                    </>
                  )}
                </>
              )}

              {activeTab === 3 && (
                <>
                  {rejectedUsers?.length === 0 ? (
                    <div className="flex flex-col items-center justify-center">
                      <p className="text-center">No Data found!</p>
                    </div>
                  ) : (
                    <>
                      {rejectedUsers?.map((list, index) => (
                        <div
                          key={index}
                          className="relative mb-4 flex flex-col gap-2 rounded-lg border border-gray-200 bg-bgWhite p-2 shadow-md md:flex-row md:justify-between"
                        >
                          <div className="flex w-full flex-col items-center justify-center gap-2 md:w-[85%] md:flex-row md:justify-between">
                            <div className="md:h-[120px] md:w-[45%] xl:h-[80px] xl:w-[20%]">
                              <img
                                src={
                                  userId === list?.requestedUser?._id
                                    ? list?.user?.images?.length > 0
                                      ? DOBASEURL + list?.user?.images?.[0]
                                      : gender === "male"
                                        ? Images.WOMEN
                                        : Images.MEN
                                    : list?.requestedUser?.images?.length > 0
                                      ? DOBASEURL +
                                        list?.requestedUser?.images?.[0]
                                      : gender === "male"
                                        ? Images.WOMEN
                                        : Images.MEN
                                }
                                onContextMenu={(e) => e.preventDefault()}
                                onDragStart={(e) => e.preventDefault()}
                                alt=""
                                className="h-full w-full rounded-xl object-cover blur"
                              />
                            </div>
                            <ul className="mt-4 flex flex-wrap items-center gap-2 text-sm">
                              {profileDetails(list)?.map((item, idx) => (
                                <li
                                  key={idx}
                                  className="flex items-center gap-1 text-base"
                                >
                                  <GoDotFill className="text-sm text-textBlack" />
                                  <span className="font-medium">
                                    {item.label} :{" "}
                                    <span className="font-normal text-textGreen">
                                      {item.value}
                                    </span>
                                  </span>
                                </li>
                              ))}
                            </ul>
                          </div>
                        </div>
                      ))}
                    </>
                  )}
                </>
              )}
            </div>
          </>
        )}
      </div>

      {showFilter && (
        <Filter
          gender={gender}
          handleShowFilter={toggleFilter}
          onApplyFilters={handleApplyFilters}
        />
      )}
      {isCommentSectionOpen && (
        <div className="popup-container fixed left-0 top-0 z-50 flex h-full w-full items-center justify-center bg-black bg-opacity-50">
          <RejectModel
            setComment={setComment}
            comment={comment}
            handleNoteChange={handleNoteChange}
            closeModal={closeModal}
            error={error}
            handleSaveComment={handleSaveComment}
            isBlocked={isBlocked}
            setIsBlocked={setIsBlocked}
          />
        </div>
      )}
      <MessageBar />
    </div>
  );
};

export default UserInterest;
